module.exports = __webpack_public_path__ + "static/media/avisoSoftwone.49623c96.pdf";